import React from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import toJS from '../hoc/toJS'
import getData from '../functions/getData'
import { PROGRAM_SELECTIONS_ITEMS, TRANSLATION } from '../constants/state'
import CollectionAccess from './CollectionAccess'
import CollectionMoviesTodayAccess from './CollectionMoviesTodayAccess'

const mapStateToProps = (state, ownProps) => ({
    selection: getData(state, [PROGRAM_SELECTIONS_ITEMS, ownProps.selectionId])
})



const SelectionAccess = ({
    htmlId,
    selectionId,
    selection
}) => {
    if(!selection.collections || !selection.collections.length > 0) {
        return ''
    }
    
    const { title, collections, filterType, filterValue} = selection
    const  collectionId = collections[0]
    const titleId = htmlId + '_section_title'
    const addSectionProps = title ? {
        'aria-labelledby': titleId
    } : {}
    
    return (
        <section id={htmlId} className="access-section" {...addSectionProps}>
            {title && <h2 id={titleId} className="access-section-title title-xlarge access-typo">{title}</h2>}

            <div className="access-section-list">
                {'moviesToday' === filterValue || 'moviesTodayByStart' === filterValue ? (
                    <CollectionMoviesTodayAccess
                        htmlId={htmlId}
                        selectionId={selectionId}
                        collectionId={collectionId}
                        filterType={filterType}
                        filterValue={filterValue}
                    />
                ) : (
                    <CollectionAccess
                        htmlId={htmlId}
                        selectionId={selectionId}
                        collectionId={collectionId}
                        filterType={filterType}
                        filterValue={filterValue}
                    />
                )}
            </div>
        </section>
    )
}

export default compose(
    connect(mapStateToProps, null),
    toJS()
)(SelectionAccess)